// extracted by mini-css-extract-plugin
export default {"cls1":"Modal-cls1__aa60df7e66fd61624bf4","cls2":"Modal-cls2___7b7ce666728e5141811 Modal-cls1__aa60df7e66fd61624bf4"};